// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__C1leo","actions":"GroupTable_actions__JEbYT","deleteModalFooter":"GroupTable_deleteModalFooter__2AvG5"};